<template>
    <div class="modal_container">
        <div class="modal">
            <div class="modal-content">
                <div class="caption">
                    <div class="title">{{textContent.titleAdd}}</div>
                    <div @click="modalClose" class="close"></div>
                </div>
                <div class="modal-scroll">
                    <form v-on:submit.prevent="addItem">
                        <form-input name="title"></form-input>
                    </form>
                    <div class="buttons">
                        <div class="next">
                            <button @click="modalClose" class="cancel">{{textContent.cancelButton}}</button>
                            <button class="confirm" @click="addItem">{{textContent.submitButton}} &#8594;</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import FormInput from '@/components/create-form/Input'
  import { createNamespacedHelpers } from 'vuex'
  import FormTextArea from '@/components/create-form/TextArea'
  import FormFile from '@/components/create-form/File'
  import Tabs from '@/components/create-form/Tabs'

  const { mapMutations, mapGetters, mapActions, mapState } = createNamespacedHelpers('mainPage')

  export default {
    computed: {
      ...mapState([
        'textContent'
      ]),
      ...mapGetters([
        'isLastTab'
      ])
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev'
      ]),
      ...mapMutations([
        'setTabs',
        'setCurrentTabId'
      ]),
    },
    created() {
      this.setCurrentTabId(0)
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Имя автора',
          errorId: null,
          errors: {empty: 'Введите имя автора'},
          tabId: 0
        }
      })
    },
    components: {
      FormInput,
      FormTextArea,
      FormFile,
      Tabs
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/authors/CreateModal.vue